import { Box, Container, Typography, Grid, Paper } from 'src/components';
import { useIsMobile } from 'src/hooks';

import trackGif from 'src/assets/videos/features/trip-tracking-desktop.png';
import discoverGif from 'src/assets/videos/features/map-locations-desktop.png';
import socialGif from 'src/assets/videos/features/map-travellers-desktop.png';

const features = [
  {
    title: 'Capture Every Mile!',
    description:
      'Track your route and build a digital adventure log filled with special memories. Create step-by-step logbooks, share journeys and watch your travel stats grow – miles driven, countries explored, and memories made.',
    image: trackGif,
  },
  {
    title: 'Find Your Next Favorite Place!',
    description:
      'Discover what not to miss with our pinned map feature! Explore must-see highlights and hidden attractions along the Pan American Highway. Star your favorites, filter by country, and uncover the extraordinary around the bend.',
    image: discoverGif,
  },
  {
    title: 'Meet Your Road Trip Tribe!',
    description:
      'Connect with fellow adventurers driving the same route and share real-time updates as you explore together. Swap stories through messaging, and join group chats with your road trip community.',
    image: socialGif,
  },
];

const FeaturesSection = () => {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ py: isMobile ? 3 : 8 }}>
      <Container>
        <Box sx={{ textAlign: 'center', mb: isMobile ? 3 : 6 }}>
          <Typography 
            variant={isMobile ? "h3" : "h2"}
            sx={{ 
              fontWeight: 700, 
              mb: 1
            }}
          >
            Why Choose Our App?
          </Typography>
          <Typography 
            variant="h5" 
            sx={{ 
              color: '#666',
              fontWeight: 400,
              maxWidth: 600,
              mx: 'auto',
              mb: isMobile ? 0 : 2
            }}
          >
            Navigate, discover and explore with confidence across two continents. From meeting other overlanders to finding the best things to do and see!
          </Typography>
        </Box>

        {features.map((feature, index) => (
          <Paper
            key={index}
            sx={{
              px: isMobile ? 2 : 9,
              py: isMobile ? 2 : 3,
              mb: 4,
              mx: isMobile ? 1 : 3,
              borderRadius: 3,
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
              '&:last-child': { mb: 0 }
            }}
          >
            <Grid 
              container 
              spacing={isMobile ? 2 : 12} 
              alignItems="center"
              direction={isMobile ? 'column' : index % 2 === 0 ? 'row' : 'row-reverse'}
              columns={2}
            >
              <Grid size={isMobile ? 2 : 1}>
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center', 
                  alignItems: isMobile ? 'center' : 'flex-start',
                  textAlign: isMobile ? 'center' : 'left',
                  height: '100%', 
                  py: isMobile ? 2 : 0 }}>

                  <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: isMobile ? 1.3 : 1.6 }}>
                    {feature.description}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={isMobile ? 2 : 1} sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Box
                  component="img"
                  src={feature.image}
                  alt={feature.title}
                  sx={{
                    width: '100%',
                    height: 250,
                    objectFit: 'cover',
                    objectPosition: 'left center',
                    borderRadius: 2,
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
        ))}
      </Container>
    </Box>
  );
};

export default FeaturesSection;